import {EventEmitter, Injectable} from '@angular/core';
import {Page} from "../models/page";

@Injectable()
export class PageService {
  // 用于控制pageChange事件的发射和订阅
  public pageChange:EventEmitter<Page> = new EventEmitter<Page>();

  constructor() { }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/page.service.ts